<template>
  <section class="py-sm-7 py-6">
    <div class="container ">
      <h1 class="mt-2 text-center display-2">Start your journey with us</h1>
      <div class="row">
        <div class="col-lg-5  mt-lg-5 mt-5">
          <p class="text-justify large-text">
            Begin your journey by following the unique instructions for each broker, available in the link.
          </p>
        </div>
        <div class="col-lg-6  mt-lg-5 mt-5 mx-auto">
          <div class=" info-horizontal d-flex align-items-end">
            <div class="col-1">
              <i class="ni ni-bold-right text-primary" aria-hidden="true"></i>
            </div>
            <div class="col-8">
              <h2 class="mb-0">Iifl </h2>
            </div>
            <div class="col-3 d-flex justify-content-end ">
              <base-button size="sm" class="" type="primary">View</base-button>
            </div>
          </div>
          <div class=" mt-3 info-horizontal d-flex align-items-end">
            <div class="col-1">
              <i class="ni ni-bold-right text-primary" aria-hidden="true"></i>
            </div>
            <div class="col-8">
              <h2 class="mb-0">Angelone </h2>
            </div>
            <div class="col-3 d-flex justify-content-end">
              <base-button size="sm" class="" type="primary">View</base-button>
            </div>
          </div>
          <div class="mt-3 info-horizontal d-flex align-items-end">
            <div class="col-1">
              <i class="ni ni-bold-right text-primary" aria-hidden="true"></i>
            </div>
            <div class="col-8">
              <h2 class="mb-0">Zerodha</h2>
            </div>
            <div class="col-3 d-flex justify-content-end">
              <base-button size="sm" class="" type="primary">View</base-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>